export default {
  header: {
    addshequn: 'Follow us',
    allproduct: "Projects",
    onproduct: "Product Surroundings",
    lineshop: "Online Store",
    heyan: "Authenticity Verification"
  },
  footer: {
    aboutus: "About Us",
    business: "Business Cooperation",
    aftersales: "After Sales & Service",
    agreement: "Service Terms",
    language: "English"
  },
  login: {
    email: "E-mail",
    code: "Verification Code",
    sendcode: 'Send',
    password: "Password",
    newpassword: "New Password",
    signin: "Login",
    signup: 'Sign up',
    signout: 'Logout',
    reset: "Reset Password",
    gologin: "Don't have an account yet?",
    goreset: "Forgot your password?",
    gosignin: "Already have an account?",
    change: "Change",
    save: "Save",
    nickname: "Nickname",
    nicknametip: "Your nickname will be displayed on the collection card",
    cropper: "Crop Picture"
  },
  user: {
    collectioncard: "Collection Card",
    message: "Message",
    edit: "Edit Profile"
  },
  content: {
    nocontent: "There's nothing there…",
    download: "Download",
    cancel: "Cancel",
    wxqun: "WeChat official community",
    followus: "Follow us",
    whoweare: "Who we are",
    whoweare1: "Founded in 2019, Zhengzhou Wo Zhike Culture Media Co., Ltd. is an innovative company dedicated to the research, development, and production of original, collectible action figures. Thanks to its exceptional product quality, it has quickly risen to become one of the leading domestic action figure brands.The company’s core R&D team consists of professionals from top modeling institutions both domestically and internationally, bringing years of industry experience and a track record of creating multiple hit products. They have established a fully integrated, in-house R&D system covering the entire process from concept art design and 3D modeling to painting engineering and product photography.",
    whoweare2:"In 2023, the company established its own production base and mold factory, achieving deep synergy between R&D and production, which significantly improved delivery efficiency and quality control standards. In early 2024, the company took the lead in introducing industry-leading 5-axis CNC engraving machines, completing a technological upgrade from traditional steel casting processes to high-precision CNC machining. This has elevated mold precision and product detail to the industry’s top level, further solidifying its technological leadership.Moving forward, Wozhike will continue to prioritize technological innovation as its core driving force, dedicated to creating high-quality, original articulated products for global figurine enthusiasts that combine artistic value with an engaging play experience.",
    kaifa_ycjn:"Original machine girl development",
    kaifa_sqcp:"Licensed Product Development",
    kaifa_more:"More possibilities",
    wetodo:"What we do",
    contactus:"Contact Us",
    contactus1:"Snail Shell is willing to cooperate with various fields of the industry.",
    contactus2:"If you have business cooperation needs in IP substantiation, cross-domain cooperation, agency retail, etc., please contact us.",
    contactusaddress:"Room 501, 5/F, Building 28, No. 28, Zhongxing Xinye Port Phase III, Interchange of East Navigation Road and Jingkai 20th Street, Zhengzhou Economic and Technological Development Zone"
  },
  verify: {
    tip: "Please scratch the authentication code area on the back of the box, enter the code into the web page, and click to verify it.",
    verifybtn: "Verify",
    where: "Where is the verification code？",
    noinfo: "Sorry, we were unable to find any information about this product.",
    firstinfo: "First time verification approved！",
    nofirstinfo: "Verified！",
    nofirsttip: "Not first time verification",
    firsttime: "Time of first verification：",
    cardstxt: "People own"
  },
  goods: {
    knowmore: "Learn more",
    buybtn: "Buy Now",
    sellstatus_yushou: 'Pre-sale',
    sellstatus_xianhuo: 'In stock',
    goodsinfo: 'Product Info',
    goodsandaside: 'Contents & Accessories',
    goodsphotos: 'Product Catalog'
  },
  tdk: {
    home: 'Snail Shell',
    products: 'Snail Shell - Projects',
    peripherals: 'Snail Shell - Peripherals',
    verify: 'Snail Shell - Anti-counterfeit verification',
    aboutUs: 'Snail Shell - Join Community',
    afterSales: 'Snail Shell - After Sales Service',
    agreement: 'Snail Shell - Terms of Service',
    userCenter:'Snail Shell',
    userEdit:'Snail Shell - Edit Profile',
    login:'Snail Shell - Login',
    reset:'Snail Shell - Reset Password',
    signUp:'Snail Shell - Sign up',
    productinfo:'Snail Shell - '
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/app-en.js